<kendo-dialog-titlebar (close)="cancel()">
  <div class="ss-dialog-title">
    {{ title | translate }}
  </div>
</kendo-dialog-titlebar>
<!-- CONTENT -->

<div class="ss-popup-container">

  <!-- WARNING CUSTOMER PRODUCT COMPONENT EXISTS -->

  <div class="ss-warning-container" *ngIf="warnCustomerComponentExists">
      <!-- WARNING TEXT -->
      <span>{{ "module.product-component.popup.warn_customer_component_exists" | translate }}</span>
      <!-- BOUTON VOIR LES COMPOSANT CLIENTS -->
      <button
        kendoButton
        type="button"
        fillMode="solid"
        themeColor="warning"
        [svgIcon]="allIcons.eyeIcon"
        (click)="showCustomerComponent()"
        >{{ "module.product-component.popup.warn_customer_component_exists_button" | translate }}</button>
      <!-- BOUTON EXCLURE LES COMPOSANTS CLIENTS-->
      <button
        kendoButton
        type="button"
        fillMode="solid"
        themeColor="error"
        [svgIcon]="allIcons.minusIcon"
        (click)="addSkipCustomerComponent()"
        [disabled]="skipCustomerComponent"
        >{{ "module.product-component.popup.warn_skip_customer_component_button" | translate }}</button>
  </div>

  <!-- BUTTONS -->

  <div class="ss-button-container">

    <!-- ADD NOTE BUTTON -->
     
    <button
      kendoButton
      class="ss-add-btn"
      type="button"
      [svgIcon]="allIcons.plusIcon"
      (click)="addNote()"
      [disabled]="skipCustomerComponent"
    >{{ "module.product-component.popup.button_add_note" | translate }}</button>

    <!-- ADD CHILD PRODUCT BUTTON -->
     
    <button
      kendoButton
      class="ss-add-btn"
      type="button"
      [svgIcon]="allIcons.plusIcon"
      (click)="addProductItem()"
      [disabled]="skipCustomerComponent"
    >{{ "module.product-component.popup.button_add_product" | translate }}</button>

  </div>

  <!-- SKIP CUSTOMER COMPONENT WARNING -->
   
  <div class="ss-skip-customer-component" *ngIf="skipCustomerComponent">
    <!-- TEXT -->
    <span class="ss-skip-customer-component-text">{{ "module.product-component.popup.label_skip_customer_component" | translate }}</span>
    <!-- BUTTON -->
    <button
      kendoButton
      class="ss-add-btn"
      type="button"
      [svgIcon]="allIcons.trashIcon"
      (click)="deleteSkipCustomerComponent()"
    >{{ "module.product-component.popup.button_undo_skip_customer_component" | translate }}</button>
   </div>

  <!-- GRID -->

  <kendo-grid
    *ngIf="!skipCustomerComponent"
    [data]="gridView"
    [pageSize]="state.take"
    [skip]="state.skip"
    [sort]="state.sort"
    [filter]="state.filter"
    [sortable]="false"
    [pageable]="pageable"
    [filterable]="false"
    [resizable]="true"
    [selectable]="gridService.selectableSettings"
    scrollable="scrollable"
    [loading]="isLoading"
    class="ss-list-grid"
    (dataStateChange)="dataStateChange($event)"
  >
    <!-- COLUMNS -->

    
    <!-- ORDER // TEMPORAIRE

    <kendo-grid-column
      field="productComponentOrder"
      title="{{ 'module.product-component.model.productComponentOrder' | translate }}"
      [width]="30"
      filter="text"
    >
    </kendo-grid-column>
     -->

    <!-- TYPE -->

    <kendo-grid-column
      field="childProductComponentType"
      title="{{ 'module.product-component.model.childProductComponentType' | translate }}"
      [width]="30"
      filter="text"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem.childProductComponentType == 'AddCommentToParent'">{{ "module.product-component.popup.label_type_note" | translate }}</span>
        <span *ngIf="dataItem.childProductComponentType == 'AddProductItemInNewLine'">{{ "module.product-component.popup.label_type_product" | translate }}</span>
        <!--<span *ngIf="dataItem.childProductComponentType == 'SkipCustomerProductComponent'">**{{ "module.product-component.popup.label_type_skip_customer_component" | translate }}</span>-->
      </ng-template>
    </kendo-grid-column>

    <!-- DESCRIPTION -->

    <kendo-grid-column
      field="lineDescription01"
      title="{{ 'module.product-component.model.lineDescription01' | translate }}"
      [width]="100"
      filter="text"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <input 
          kendoTextBox
          type="text"
          class="ss-input"
          name="lineDescription01"
          [(ngModel)]="dataItem.lineDescription01"
          (change)="update(dataItem, $event)"/>
      </ng-template>
    </kendo-grid-column>

    <!-- PRODUCT ITEM ID -->

    <kendo-grid-column
      field="childProductItemId"
      title="{{ 'module.product-component.model.childProductItem' | translate }}"
      [width]="130"
      filter="numeric"
      format="0n0"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem.childProductItemId">{{ dataItem.childProductItem.productItemNumber}} - {{ dataItem.childProductItem.productItemTitleFr}}</span>
      </ng-template>
    </kendo-grid-column>

    <!-- QUANTITY -->

    <kendo-grid-column
      field="childQuantityMultiplicator"
      title="{{ 'module.product-component.model.childQuantityMultiplicator' | translate }}"
      [width]="40"
      filter="numeric"
      format="n0"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <input 
          *ngIf="dataItem.childProductComponentType == 'AddProductItemInNewLine'"
          kendoTextBox
          type="number"
          class="ss-input"
          name="childQuantityMultiplicator"
          min="1"
          [(ngModel)]="dataItem.childQuantityMultiplicator"
          (focus)="lastQuantity = dataItem.childQuantityMultiplicator"
          (change)="update(dataItem, $event)"/>
      </ng-template>
    </kendo-grid-column>

    <!-- PRICE INCLUDED -->

    <kendo-grid-column
      field="includePriceInParent"
      title="{{ 'module.product-component.model.includePriceInParent' | translate }}"
      [width]="40"
      filter="boolean"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <input
          *ngIf="dataItem.childProductComponentType == 'AddProductItemInNewLine'"
          kendoCheckBox
          class="ss-checkbox"
          type="checkbox"
          name="includePriceInParent"
          [(ngModel)]="dataItem.includePriceInParent"
          (change)="update(dataItem, $event)"/>
        
      </ng-template>
    </kendo-grid-column>

    <!-- ACTION -->

  <kendo-grid-column
    field="action"
    [width]="40"
    [minResizableWidth]="80"
    title="Action"
  >
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">

      <!-- DELETE -->
      <button
        kendoButton
        [svgIcon]="allIcons.trashIcon"
        themeColor="primary"
        fillMode="flat"
        (click)="delete(dataItem)"
        type="button"
      ></button>

      <!-- UP -->
      <button
        kendoButton
        [svgIcon]="allIcons.arrowUpIcon"
        themeColor="primary"
        fillMode="flat"
        (click)="changeOrder(dataItem, -1)"
        type="button"
        [disabled]="rowIndex === 0"
      ></button>

      <!-- DOWN -->
      <button
        kendoButton
        [svgIcon]="allIcons.arrowDownIcon"
        themeColor="primary"
        fillMode="flat"
        (click)="changeOrder(dataItem, 1)"
        type="button"
        [disabled]="rowIndex === gridView.data.length - 1"
      ></button>

    </ng-template
  ></kendo-grid-column>

  </kendo-grid>
</div>
